module.exports = __webpack_public_path__ + "static/media/ic_kran.ddb3fb9b.png";